// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import SessionDocumentsController from "./session_documents_controller"
application.register("session-documents", SessionDocumentsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)
